import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { Registry } from 'vscode/vscode/vs/platform/registry/common/platform';
import { Extensions } from 'vscode/vscode/vs/workbench/common/contributions';
import { IStorageService } from 'vscode/vscode/vs/platform/storage/common/storage.service';
import { IBrowserWorkbenchEnvironmentService } from 'vscode/vscode/vs/workbench/services/environment/browser/environmentService.service';
import { IConfigurationService } from 'vscode/vscode/vs/platform/configuration/common/configuration.service';
import { Disposable } from 'vscode/vscode/vs/base/common/lifecycle';
import { ContextKeyExpr } from 'vscode/vscode/vs/platform/contextkey/common/contextkey';
import { IContextKeyService } from 'vscode/vscode/vs/platform/contextkey/common/contextkey.service';
import { ICodeEditorService } from 'vscode/vscode/vs/editor/browser/services/codeEditorService';
import { IInstantiationService } from 'vscode/vscode/vs/platform/instantiation/common/instantiation';
import { ICommandService } from 'vscode/vscode/vs/platform/commands/common/commands.service';
import { WelcomeWidget } from './welcomeWidget.js';
import { ITelemetryService } from 'vscode/vscode/vs/platform/telemetry/common/telemetry.service';
import { IOpenerService } from 'vscode/vscode/vs/platform/opener/common/opener.service';
import { Extensions as Extensions$1 } from 'vscode/vscode/vs/platform/configuration/common/configurationRegistry';
import { localizeWithPath } from 'vscode/vscode/vs/nls';
import { applicationConfigurationNodeBase } from 'vscode/vscode/vs/workbench/common/configuration';
import { RunOnceScheduler } from 'vscode/vscode/vs/base/common/async';
import { IEditorService } from 'vscode/vscode/vs/workbench/services/editor/common/editorService.service';

const _moduleId = "vs/workbench/contrib/welcomeDialog/browser/welcomeDialog.contribution";
const configurationKey = 'workbench.welcome.experimental.dialog';
let WelcomeDialogContribution = class WelcomeDialogContribution extends Disposable {
    constructor(storageService, environmentService, configurationService, contextService, codeEditorService, instantiationService, commandService, telemetryService, openerService, editorService) {
        super();
        this.isRendered = false;
        if (!storageService.isNew(-1 )) {
            return;
        }
        const setting = configurationService.inspect(configurationKey);
        if (!setting.value) {
            return;
        }
        const welcomeDialog = environmentService.options?.welcomeDialog;
        if (!welcomeDialog) {
            return;
        }
        this._register(editorService.onDidActiveEditorChange(() => {
            if (!this.isRendered) {
                const codeEditor = codeEditorService.getActiveCodeEditor();
                if (codeEditor?.hasModel()) {
                    const scheduler = ( (new RunOnceScheduler(() => {
                        const notificationsVisible = contextService.contextMatchesRules(ContextKeyExpr.deserialize('notificationCenterVisible')) ||
                            contextService.contextMatchesRules(ContextKeyExpr.deserialize('notificationToastsVisible'));
                        if (codeEditor === codeEditorService.getActiveCodeEditor() && !notificationsVisible) {
                            this.isRendered = true;
                            const welcomeWidget = ( (new WelcomeWidget(
                                codeEditor,
                                instantiationService,
                                commandService,
                                telemetryService,
                                openerService
                            )));
                            welcomeWidget.render(welcomeDialog.title, welcomeDialog.message, welcomeDialog.buttonText, welcomeDialog.buttonCommand);
                        }
                    }, 3000)));
                    this._register(codeEditor.onDidChangeModelContent((e) => {
                        if (!this.isRendered) {
                            scheduler.schedule();
                        }
                    }));
                }
            }
        }));
    }
};
WelcomeDialogContribution = ( (__decorate([
    ( (__param(0, IStorageService))),
    ( (__param(1, IBrowserWorkbenchEnvironmentService))),
    ( (__param(2, IConfigurationService))),
    ( (__param(3, IContextKeyService))),
    ( (__param(4, ICodeEditorService))),
    ( (__param(5, IInstantiationService))),
    ( (__param(6, ICommandService))),
    ( (__param(7, ITelemetryService))),
    ( (__param(8, IOpenerService))),
    ( (__param(9, IEditorService)))
], WelcomeDialogContribution)));
( (Registry.as(Extensions.Workbench)))
    .registerWorkbenchContribution(WelcomeDialogContribution, 4 );
const configurationRegistry = ( (Registry.as(Extensions$1.Configuration)));
configurationRegistry.registerConfiguration({
    ...applicationConfigurationNodeBase,
    properties: {
        'workbench.welcome.experimental.dialog': {
            scope: 1 ,
            type: 'boolean',
            default: false,
            tags: ['experimental'],
            description: ( localizeWithPath(_moduleId, 0, "When enabled, a welcome widget is shown in the editor"))
        }
    }
});
